import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/diaries/$diaryId/edit/tracker/$trackerId/follow-up-method')({
    component: () => <div>Hello /_app/diary/$diaryId/tracker/$trackerId/edit/pifu!</div>,
});
